<template>
  <div class="stats">
    <div class="stat">
      <div class="label">{{ dateLabel }}</div>
      <div class="value">{{ dateValue | shortDate }}</div>
    </div>
    <div class="stat" v-if="book.status === 'Available'">
      <div class="label">{{ thisMonthName }}</div>
      <div class="value">{{ book.stats.this_month_reviews | reviews }}</div>
    </div>
    <div class="stat-empty" v-else></div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["book"],
  components: {},
  data: function() {
    return {};
  },
  computed: {
    dateLabel() {
      if (this.book.status === "Available") {
        return "Live on";
      }
      return "Added on";
    },
    dateValue() {
      if (this.book.status === "Available") {
        return this.book.available_at;
      }
      return this.book.created_at;
    },
    thisMonthName() {
      const date = new Date();
      return date.toLocaleString("en-us", { month: "long" });
    }
  }
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .stats {
    width: 220px;
    margin: 0 auto !important;
    margin-top: -8px !important;
    padding: 0px 10px !important;
  }
}

.stats {
  margin: 0px 0;
  padding: 22px 10px;
}
.stat {
  padding-bottom: 1px;
}
.label {
  display: inline-block;
  width: 100px;
  font-size: 12pt;
  font-weight: 700;
  color: #2196f3;
  font-family: "Source Sans Pro";
}
.value {
  display: inline-block;
  width: 90px;
  font-size: 12pt;
  font-weight: 300;
  color: #222;
  font-family: "Source Sans Pro";
}

.stat-empty {
  height: 25px;
}
</style>
